import { createContext, useContext, useEffect, useState } from "react";
import { SEO } from "@/data/content";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("site-lang") === "en" ? "en" : "ar";
        } catch {
            return "ar";
        }
    });

    useEffect(() => {
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
        document.title = SEO[lang].title;
        const desc = document.querySelector('meta[name="description"]');
        if (desc) desc.setAttribute("content", SEO[lang].desc);
        try {
            localStorage.setItem("site-lang", lang);
        } catch {
            /* storage unavailable */
        }
    }, [lang]);

    const L = (obj) => (obj && typeof obj === "object" ? obj[lang] : obj);

    return (
        <LanguageContext.Provider
            value={{ lang, setLang, L, dir: lang === "ar" ? "rtl" : "ltr" }}
        >
            {children}
        </LanguageContext.Provider>
    );
}

export const useLanguage = () => useContext(LanguageContext);
